<!-- prettier-ignore  -->
<template>
  <div class="space-y-1 text-sm px-5 py-2 pt-4">
    <div v-if="slot.phone">
      <aw-icon icon="phone" class="h-4 w-5 " /> <a :href="'tel:' + normalizePhoneForCall(slot.phone)">{{ slot.phone }}</a>
    </div>
    <div v-if="slot.email">
      <aw-icon icon="email" class="h-4 w-5 " /> <a :href="'mailto:' + slot.email">{{ slot.email }}</a>
    </div>
    <div>Powered by BrandCloud.pro</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultSlot: {
        name: this.$t('Content manager'),
        phone: '+420 777 211 344',
        email: 'info@brandcloud.pro',
        translated: false
      },
      filledSlot: {
        name: this.$presenter.design.rp_name,
        phone: this.$presenter.design.rp_phone,
        email: this.$presenter.design.rp_email,
        translated: true
      }
    }
  },
  computed: {
    slot() {
      return this.filledSlot.name ? this.filledSlot : this.defaultSlot
    }
  },
  methods: {
    normalizePhoneForCall(phone) {
      return phone.replaceAll(' ', '')
    }
  },
}
</script>

<style lang="scss" scoped></style>
